{
    "action__edit_all": "Alle Bearbeiten",
    "action__cancel_edit_all": "Abbrechen",
    "action__save_edit_all": "Speichern",
    "action__mark_customer_as_inactive": "Inaktiv setzen",
    "action__mark_customer_as_active": "Aktiv setzen",
    "analysis__title": "Analyse",
    "analysis__show_more_one": "{{count}} weitere",
    "analysis__show_more_other": "{{count}} weitere",
    "mark_inactive_dialog__title": "Kunden inaktiv setzen?",
    "mark_inactive_dialog__bullet_recommendations": "KI-Empfehlungen für diesen Kunden werden pausiert.",
    "mark_inactive_dialog__bullet_recommendations_tooltip": "Für diesen Kunden werden keine Vertriebsempfehlungen mehr angezeigt.",
    "mark_inactive_dialog__bullet_plato_only": "Nur in Plato wirksam",
    "mark_inactive_dialog__bullet_plato_only_tooltip": "Die Warenwirtschaft ist nicht betroffen.",
    "mark_inactive_dialog__bullet_reversible": "Du kannst den Kunden jederzeit wieder auf aktiv setzen.",
    "mark_inactive_dialog__reason_label": "Grund",
    "mark_inactive_dialog__reason_business_closed": "Geschäftstätigkeit eingestellt",
    "mark_inactive_dialog__reason_merged_accounts": "Kunden zusammengelegt",
    "mark_inactive_dialog__reason_other": "Andere",
    "mark_inactive_dialog__reason_other_placeholder": "Bitte Grund angeben",
    "mark_inactive_dialog__success_toast_title": "Kunde als inaktiv gesetzt",
    "mark_inactive_dialog__success_toast_description": "Empfehlungen pausiert.",
    "mark_active_dialog__title": "Kunden aktiv setzen?",
    "mark_active_dialog__bullet_recommendations": "KI-Empfehlungen für diesen Kunden werden wieder aktiviert.",
    "mark_active_dialog__bullet_plato_only": "Nur in Plato wirksam",
    "mark_active_dialog__bullet_plato_only_tooltip": "Die Warenwirtschaft ist nicht betroffen.",
    "mark_active_dialog__reason_label": "Grund",
    "mark_active_dialog__reason_resumed_operations": "Geschäftstätigkeit wieder aufgenommen",
    "mark_active_dialog__reason_other": "Andere",
    "mark_active_dialog__reason_other_placeholder": "Bitte Grund angeben",
    "mark_active_dialog__success_toast_title": "Kunde aktiv gesetzt",
    "mark_active_dialog__success_toast_description": "Empfehlungen sind ab morgen wieder verfügbar.",
    "navigation_tab__activities": "Aktivitäten",
    "navigation_tab__analysis": "Umsatzanalysen",
    "navigation_tab__info": "Kundendaten",
    "glance__title": "Auf einen Blick",
    "stats__decoration_gm": "DB",
    "stats__decoration_order_sum": "Auftragseingang",
    "stats__decoration_revenue": "Umsatz",
    "stats__ytd_label": "Lfd. Jahr {{year}}",
    "stats__activities_stats_label": "Aktivitätsstatistiken",
    "stats__open_orders": "Offene Aufträge",
    "stats__open_quotes": "Offene Angebote",
    "tab_title__contacts": "Kontakte",
    "tab_title__addresses": "Versandadressen",
    "credit__title": "Verwendeter Kredit",
    "customer_detail__header__new_activity": "Neue Aktivität",
    "customer_detail__header__task": "Neue Aufgabe",
    "customer_detail__header__draft": "Neuer Vorgang",
    "customer_detail__timeline": "Aktivitäten",
    "customer_detail__past_activities": "Vergangen",
    "customer_detail__all_activities": "Alle",
    "customer_detail__tasks": "Aufgaben",
    "customer_detail__notes": "Interaktionen",
    "customer_detail__open_tasks": "Offen",
    "customer_detail__insight_outcomes": "Vertriebsempfehlungen",
    "activity_feed__filter_users": "Benutzer",
    "activity_feed__filter_customers": "Kunden",
    "customer_detail__status_changes": "Statusänderungen",
    "customer_detail__marked_inactive": "Kunde als inaktiv markiert",
    "customer_detail__marked_active": "Kunde als aktiv markiert",
    "customer_detail__completed_tasks": "Erledigt",
    "customer_detail__quotes": "Angebote",
    "customer_detail__orders": "Aufträge",
    "status_description_new_with_orders": "Der Kunde hat {{daysSinceLastOrder}} seine erste Bestellung aufgegeben.",
    "status_description_new_no_orders": "Der Kunde hat noch nichts bestellt.",
    "status_description_active": "Dieser Kunde bestellt regelmäßig.",
    "status_description_at_risk_with_churn": "Auffällig, der Kunde bestellt nicht mehr wie gewohnt.",
    "status_description_at_risk_revenue_decline": "Der Kunde kauft deutlich weniger und hat einen Umsatzrückgang von {{revenueDeclinePercent, number}} in den letzten 12 Monaten.",
    "status_description_dormant": "Die letzte Bestellung war vor über {{monthsSinceLastOrder}} Monaten.",
    "status_description_inactive_reason": "Dieser Kunde wurde manuell als inaktiv markiert.",
    "status_description_blocked": "Dieser Kunde ist im ERP gesperrt. Sein Status kann in Plato nicht geändert werden.",
    "field_label__address__canReceiveGoodsAtNight": "Spätlieferung möglich",
    "field_label__address__canReceiveParcels": "Paketlieferung möglich",
    "field_label__address__comment": "Kommentar",
    "field_label__address__isPreferredShippingAddress": "Bevorzugte Lieferadresse",
    "field_label__address__preset__address_formatted": "Adresse",
    "field_label__contact__birthday": "Geburtstag",
    "field_label__contact__comment": "Kommentar",
    "field_label__contact__department": "Abteilung",
    "field_label__contact__email": "Email",
    "field_label__contact__fax": "Fax",
    "field_label__contact__firstName": "Vorname",
    "field_label__contact__lastName": "Nachname",
    "field_label__contact__mobile": "Mobil",
    "field_label__contact__name": "Name",
    "field_label__contact__phone": "Telefon",
    "field_label__contact__role": "Position",
    "field_label__contact__salutation": "Anrede",
    "field_label__customer__annualSalesPotential": "Jährliches Potential",
    "field_label__customer__associationMemberships": "Verbandsmitgliedschaften",
    "field_label__customer__branch": "Standort",
    "field_label__customer__customerType": "Kundenart",
    "field_label__customer__dunningLevel": "Mahnstufe",
    "field_label__customer__emailAddress": "Email",
    "field_label__customer__employeeCount": "Employee count",
    "field_label__customer__firstOrderDate": "Erster Auftrag",
    "field_label__customer__facebookUrl": "Facebook",
    "field_label__customer__faxNumber": "Fax",
    "field_label__customer__industrySector": "Branche",
    "field_label__customer__lastOrderDate": "Letzter Auftrag",
    "field_label__customer__linkedInUrl": "LinkedIn",
    "field_label__customer__openOrderCount": "Offene Aufträge",
    "field_label__customer__openQuoteCount": "Offene Angebote",
    "field_label__customer__orderBlock": "Auftragssperre",
    "field_label__customer__overdueInvoiceCount": "Offene Rechnungen",
    "field_label__customer__ownExhibition": "Eigene Ausstellung",
    "field_label__customer__paymentTerms": "Zahlungsbedingungen",
    "field_label__customer__phoneNumber": "Telefon",
    "field_label__customer__potentialReachedTtm": "Potentialausschöpfung (12M)",
    "field_label__customer__potentialReachedYtd": "Potentialausschöpfung (YTD)",
    "field_label__customer__preset__customer_address": "Anschrift",
    "field_label__customer__preset__customer_creditLimit": "Kreditlimit",
    "field_label__customer__preset__customer_externalSalesReps": "Außendienst",
    "field_label__customer__preset__customer_gridCreditLimit": "Kreditlimit",
    "field_label__customer__preset__customer_internalSalesReps": "Innendienst",
    "field_label__customer__priceGroup": "Preisgruppe",
    "field_label__customer__quoteWinRateTtm": "Gewonnene / Alle Angebote L12M",
    "field_label__customer__region": "Region",
    "field_label__customer__revenueTtm": "Umsatz Letzte 12 Monate",
    "field_label__customer__revenueYtd": "Umsatz Laufendes Jahr",
    "field_label__customer__taxNumber": "Steuernummer",
    "field_label__customer__totalOrderCount": "Anzahl der Aufträge",
    "field_label__customer__unbilledLineItemTotal": "Noch nicht fakturiert",
    "field_label__customer__websiteUrl": "Website",
    "tab__customer__accounting": "Buchhaltung",
    "tab__customer__general": "Allgemein",
    "tab__customer__sales": "Vertrieb",
    "save_error": "Fehler beim Speichern",
    "save_successful": "Werte erfolgreich gespeichert",
    "address_edit__modal_title": "Adresse bearbeiten",
    "address_edit__modal_subtitle": "Diese Informationen sind für alle einsehbar",
    "address_edit__action__save": "Speichern",
    "contact_edit__modal_title": "Kontakt bearbeiten",
    "contact_edit__modal_subtitle": "Diese Informationen sind für alle einsehbar",
    "contact_edit__action__save": "Speichern",
    "field_placeholder__contact__birthday": "01.01.1980",
    "field_placeholder__contact__comment": "Kommentar eingeben",
    "field_placeholder__contact__department": "Abteilung eingeben",
    "field_placeholder__contact__email": "m.mustermann@email.de",
    "field_placeholder__contact__mobile": "030 2035339",
    "field_placeholder__contact__name": "Max Mustermann",
    "field_placeholder__contact__phone": "030 2035339",
    "field_placeholder__contact__role": "Position eingeben",
    "field_placeholder__contact__salutation": "Anrede eingeben",
    "field_placeholder__contact__title": "Dr.",
    "field_placeholder__day": "Tag",
    "field_placeholder__month": "Monat",
    "field_placeholder__year_optional": "Jahr (optional)",
    "field_option__year_unknown": "Unbekannt"
}
